import React from "react";
import { View, StyleSheet } from "react-native";
import S3Image from "screens/common/S3Image";
import { Colors } from "styled42/config";
import SClickableArea from "styled42/components/SClickableArea";
import ProgressBarComponent from "screens/LoginRegistration/utils/ProgressBar";
import SText from "styled42/components/SText";

const NavHeader = ({
  progressStatus,
  maxValue,
  primaryText,
  secondaryText,
  containerStyle,
  onBack,
  testID,
  accessibilityLabel
}) => (
  <View style={[styles.container, containerStyle]}>
    {progressStatus && (
      <ProgressBarComponent
        progressStatus={progressStatus}
        maxValue={maxValue}
      />
    )}
    <View style={styles.bodyContainer}>
      {onBack ? (
        <SClickableArea
          onClick={onBack}
          testID={testID}
          accessibilityLabel={accessibilityLabel}
        >
          <S3Image
            path="RocketIntegration"
            name="BackIcon"
            islazyLoadRequired={false}
            style={styles.icon}
          />
        </SClickableArea>
      ) : (
        <View style={styles.extraMargin} />
      )}
      {primaryText || secondaryText ? (
        <View style={styles.textContainer}>
          {primaryText && (
            <SText size={18} weight="700">
              {primaryText}
            </SText>
          )}
          {secondaryText && (
            <SText size={12} weight="400" color="#676574">
              {secondaryText}
            </SText>
          )}
        </View>
      ) : null}
    </View>
  </View>
);

const styles = StyleSheet.create({
  container: {
    backgroundColor: Colors.White[1]
  },
  icon: {
    marginRight: 10,
    width: 20,
    height: 16,
    marginTop: 3
  },
  bodyContainer: {
    marginHorizontal: 16,
    marginTop: 16,
    flexDirection: "row",
    backgroundColor: "transparent"
  },
  textContainer: {
    flexDirection: "column"
  },
  extraMargin: { margin: 4 }
});

export default NavHeader;
